import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import BackIcon from '../../../assets/svg/backArrow.svg';
import { StepSwitch } from '../components/StepSwitch';
import { STEPS } from '../consts';
import { FlowContext, IFlowContext } from '../context';
import { getInitialStep, getNavHeaderFromActiveStep, getNextStepFromActiveStep } from '../services';
import { validateFeatureFlag } from '../../../services/featureFlagService';
import { FEATURE_FLAG } from '../../../constants/general';
import Button from '../../../generic-components/Button';
import Icon from '../../../generic-components/Icon';
import Heading from '../../../generic-components/Heading';
import { Layout } from '../../../components/Layout/Layout';

export const SavingsBucket = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  /** Local State */
  const [activeStep, setActiveStep] = useState<string>(STEPS.PRE_LOAD);
  const [moneyMovementMode, setMoneyMovementMode] = useState<boolean>(false);
  const [isSavingsBucket] = useState(validateFeatureFlag(FEATURE_FLAG.EMERGENCY_SAVING_ACCOUNT));
  /** --- */

  /** Flow Context Props */
  const contextProps = useMemo((): IFlowContext => ({
    changeActiveStep: (step: string) => setActiveStep(step),
    changeMoneyMovementMode: (mode: boolean) => setMoneyMovementMode(mode),
    moneyMovementMode,
    isSavingsBucket,
  }), [activeStep]);
  /** --- */

  /** Computed Values */
  const navHeader = useMemo(() => getNavHeaderFromActiveStep(activeStep, moneyMovementMode, isSavingsBucket, t), [activeStep, moneyMovementMode]);
  /** --- */

  function handleNavigate() {
    const { nextStep, reqNav } = getNextStepFromActiveStep(activeStep);
    if (reqNav && nextStep) {
      navigate(nextStep);
    } else if (!reqNav && nextStep) {
      setActiveStep(nextStep);
    }
  }

  useEffect(() => {
    setActiveStep(getInitialStep());
  }, []);

  return (

    <Layout wrapperClassName='pt-[78px] pl-[72px] pr-[32px] ml-[100px] pc-md:ml-[256px]'>
      <div className='flex items-center gap-[24px] mb-[24px]'>
        <Button
          onClick={() => handleNavigate()}
          className=''
          id='backActivateCard'
          childElement={<Icon className='w-[10px]' src={BackIcon} />}
        />
        <Heading title={navHeader} className='font-metricRSemibold text-bw08 text-[20px]' />
      </div>
      <FlowContext.Provider value={contextProps}>
        <StepSwitch step={activeStep} />
      </FlowContext.Provider>
    </Layout>
  );
};
